import { useEffect } from "react";
import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { HenryLoadingContainer, HenryLottieContainer } from "./styles";
import { LottieAnimation } from "@manifesthhqinc/ui-library";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import Spacing from "../../../layout/spacing";

const HenryQuestionnaireLoading = (props: UseHenryQuestionniareProps) => {
  const { setIsLoading, showResult } = props;
  useEffect(() => {
    setIsLoading(true);
  }, []);
  return (
    <TransitionWrapper>
      <HenryLoadingContainer>
        <HenryLottieContainer>
          <LottieAnimation type="henry-loading" autoplay onComplete={showResult} height={200} width={200} />
        </HenryLottieContainer>
        <Spacing vertical="11" />
        <HeadlineMedium>Just a moment...</HeadlineMedium>
        <Spacing vertical="8" />
        <BodyLargeRegular $textAlign="center">I’m putting together the best transfer options for you.</BodyLargeRegular>
      </HenryLoadingContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireLoading;
